class LoadingIndicator {
    name: string;
    _root: HTMLElement;
    _indicator: HTMLElement;

    constructor( root: HTMLElement ) {
        this.name = root.dataset.loadingIndicator || '';
        this._root = root;
        this._indicator = newIndicatorElement();
        this._root.appendChild( this._indicator );
        this._root.dataset.loadingIndicatorInitialised = 'true';
    }

    show(): void {
        this._indicator.classList.add( 'loadingindicator--loading' );
    }

    hide(): void {
        this._indicator.classList.remove( 'loadingindicator--loading' );
    }
}

function newIndicatorElement(): HTMLElement {
    const el: HTMLElement = document.createElement( 'div' );
    el.className = 'loadingindicator';
    el.insertAdjacentHTML( 'beforeend', '<div></div>' );
    return el;
}

export default LoadingIndicator;

export function initLoadingIndicatorsByName( name: string ): Array<LoadingIndicator> {
    const result: Array<LoadingIndicator> = [];

    document.querySelectorAll<HTMLElement>( `[data-loading-indicator="${name}"]` ).forEach( ( el: HTMLElement ) => {
        if ( !el.dataset.loadingIndicatorInitialised ) {
            el[ 'loadingIndicator' ] = new LoadingIndicator( el );
        }
        result.push( el[ 'loadingIndicator' ] );
    } );

    return result;
}
